import de from './de'
import en from './en'
import fr from './fr'
import pt from './pt'
import fi from './fi'
import es from './es'  // Spanish import
import it from './it'  // Italian import

export default {
  de,
  en,
  fr,
  pt,
  fi,
  es,  // Spanish
  it,  // Italian
}
